import styled from "styled-components";

export const Header = styled.div`
  display: flex;
  justify-content: flex-end;
  padding: 15px 10px 0px;
  background: var(--filter-bar-bg);
`;

export const GridContainer = styled.div`
  margin: 20px;
`;

export const FilterGroupContainer = styled.div`
  width: 300px;
  height: 50px;
  margin-left: 10px;
`;

export const LeftSpace = styled.div`
  margin-left: 10px;
`;

export const ButtonParent = styled.div`
  display: 'block'
`;

export const ModalTitle = styled.div`
  font-size: 25px;
  color: #bc9b6a;
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ModalButton = styled.div`
  margin-top: 20px;
  display: flex;
  justify-content: flex-end;
`;

export const EditPersonTabs = styled.div`
    .k-tabstrip-items .k-link {
        color: #bc9b6a;
    }
    `;

